import { ProgressBar } from "@/components/ui/progress-bar";

interface TestProgressBarProps {
  completed: number;
  total: number;
  validating: number;
  inProgress: number;
}

export function TestProgressBar(props: TestProgressBarProps) {
  return (
    <ProgressBar
      tooltip
      items={[
        {
          name: "In Progress",
          color: "yellow",
          count: props.inProgress,
        },
        {
          name: "Validating",
          color: "blue",
          count: props.validating,
        },
        {
          name: "Completed",
          color: "green",
          count: props.completed,
        },
      ]}
    />
  );
}
